import * as React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core";

const styles = (theme) => {
  return {
    paper: {
      padding: 20,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-around",
      textAlign: "center",
    },
    metricName: {
      fontSize: 30,
      fontWeight: 500,
      color: theme.palette.primary.main,
      textAlign: "center",
    },
  };
};

const MetricsCard = ({ classes, cardContent, cardTitle, paperStyle = {} }) => {
  return (
    <Paper className={classes.paper} style={paperStyle}>
      <Typography variant="h4" className={classes.metricName}>
        {cardTitle}
      </Typography>
      {cardContent}
    </Paper>
  );
};

export default withStyles(styles)(MetricsCard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/MetricsCard/index.jsx